import {makeActionCreator} from '../utility'

export const VERIFY_CERTIFICATE = 'VERIFY_CERTIFICATE'
export const verifyCertificate = makeActionCreator(VERIFY_CERTIFICATE, 'data')


export const VERIFY_CERTIFICATE_SUCCESSFULL = 'VERIFY_CERTIFICATE_SUCCESSFULL'
export const verifyCertificateSuccessfull = makeActionCreator(VERIFY_CERTIFICATE_SUCCESSFULL, 'data')